import { Task } from '@weave/schema-gen-ts/dist/schemas/task-center/shared/v1/task.pb';
import { UpdateTaskRequest } from '@weave/schema-gen-ts/dist/schemas/task-center/v1/task_service.pb';
import { DemoIdUtils } from '@frontend/demo-interceptors';

/**
 * Holds fields patched through the mocked UpdateTask endpoint, keyed by demo-prefixed task id, so that
 * subsequent ListTasksV2 responses reflect edits made in Task Center during the demo session.
 */
const overrides = new Map<string, Partial<Task>>();

type PatchableTaskField = Exclude<Extract<keyof Task, keyof UpdateTaskRequest>, 'id'>;
type TaskPatch = Partial<Pick<Task, PatchableTaskField>>;

const PATCHABLE_TASK_FIELDS: PatchableTaskField[] = [
  'title',
  'description',
  'status',
  'assignee',
  'dueDate',
  'dueDateHasTime',
  'patient',
  'priority',
];

const copyField = <K extends PatchableTaskField>(target: TaskPatch, source: UpdateTaskRequest, field: K) => {
  if (source[field] !== undefined) target[field] = source[field];
};

export const DemoTaskOverrides = {
  set: (id: string, patch: UpdateTaskRequest) => {
    const key = DemoIdUtils.addDemoPrefix(id);
    const fields: TaskPatch = {};
    PATCHABLE_TASK_FIELDS.forEach((field) => copyField(fields, patch, field));
    overrides.set(key, { ...overrides.get(key), ...fields });
  },
  apply: <T extends Task>(task: T): T => {
    const patch = task.id ? overrides.get(DemoIdUtils.addDemoPrefix(task.id)) : undefined;
    return patch ? { ...task, ...patch } : task;
  },
  clear: () => overrides.clear(),
};
